import { TableCell, TableRow } from "@material-ui/core";
import {
	DatatablesFooterServerSide,
	Loading,
	TableAction,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { defaultDateDisplay } from "App/utils/helpers";
import { FreezeTable } from "components/organism";
import { headCellsLokasi } from "./helpers";

export default function OrganisasiLokasiTable({
	rows,
	resetPagination,
	handleChildren,
	totalData,
	handleCloseModal,
	setNewData,
	pagination,
	onPrevious,
	onNext,
	handleClickPageNumber,
	handleChangeLimit,
	loading,
	handleChange,
	formFilter,
	setFormFilter,
}) {
	const { order, orderBy, handleRequestSort, length } = useDatatables({
		rows: rows,
		orderByDefault: "date",
		orderByRow: ["date", "id"],
	});

	return (
		<>
			<Loading show={loading} />

			<FreezeTable
				headCells={headCellsLokasi}
				handleRequestSort={handleRequestSort}
				order={order}
				length={length}
				orderBy={orderBy}
			>
				{stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
					return (
						<TableRow key={index}>
							<TableCell align="center">{index + 1}</TableCell>
							<TableCell align="center">
								<TableAction
									isDelete={false}
									isUpdate={false}
									isSelect={true}
									clickSelect={() => handleCloseModal(row)}
									isRefresh={true}
									clickRefresh={() => handleChildren(row)}
								/>
							</TableCell>
							<TableCell align="left">{row?.kode}</TableCell>
							<TableCell align="left">{row?.name}</TableCell>
							<TableCell align="left">{row?.description}</TableCell>
							<TableCell align="left">{row?.status}</TableCell>
							<TableCell align="left">{row?.mode}</TableCell>
							<TableCell align="left">{row?.type}</TableCell>
							<TableCell align="left">
								{defaultDateDisplay(row?.createdAt)}
							</TableCell>
							<TableCell align="left">{row?.createdBy}</TableCell>
							<TableCell align="left">
								{defaultDateDisplay(row?.updatedAt)}
							</TableCell>
							<TableCell align="left">{row?.updatedBy}</TableCell>
						</TableRow>
					);
				})}
				{rows.length === 0 && (
					<TableRow>
						<TableCell align="center" colSpan={headCellsLokasi.length}>
							Tidak ada data
						</TableCell>
					</TableRow>
				)}
			</FreezeTable>
			<DatatablesFooterServerSide
				totalData={totalData}
				pagination={pagination}
				handleChangeLimit={handleChangeLimit}
				onPrevious={onPrevious}
				onNext={onNext}
				currentPage={pagination.page}
				handleClickPageNumber={handleClickPageNumber}
			/>
		</>
	);
}
